import axios from 'axios';
import _path from 'ramda/src/path';
import request from './AxiosRequest';
import GeneralUtility from '../utilities/generalUtility';

let initOnce = false;
let pending = [];
let error = false;
let cancel = null;
let connections = null;
const pendingRequests = [];

const defer = () => {
    var deferred = {};
    var promise = new Promise((resolve, reject) => {
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    deferred.promise = promise;
    return deferred;
};

const init = () => {
    if (initOnce) {
        return;
    }

    initOnce = true;

    const r = request({
        url: `/Services/api/contacts/relationships`,
        method: 'GET',
        cancel: true
    });

    cancel = r.cancel;
    GeneralUtility.appendPendingRequest(pendingRequests, r);
    r.request
        .then(response => {
            connections = response.data;
            pending.forEach(pendingRequest => {
                pendingRequest.resolve(connections);
            });
        })
        .catch(error => {
            if (!axios.isCancel(error)) {
                error = true;
                pending.forEach(pendingRequest => {
                    pendingRequest.reject(error);
                });
                GeneralUtility.logWebRequestFailure(error, 'GetConnections');
            }
        });
};

const browse = () => {
    if (!initOnce) {
        init();
    }
    if (connections) {
        return { request: Promise.resolve(connections), cancel: cancel };
    }
    if (error) {
        return { request: Promise.reject(new Error('fail')), cancel: cancel };
    }

    const pendingRequest = defer();
    pending.push(pendingRequest);
    return { request: pendingRequest.promise, cancel: cancel };
};

const add = data => {
    const r = request({
        url: `/Services/ContactService.svc/json/Save`,
        method: 'POST',
        data
    });

    r.then(response => {
        const original = connections.find(i => i.UserId === data.contact.KnownContactUserId);
        const update = connections.filter(i => i.UserId !== data.contact.KnownContactUserId);

        update.push({
            UserId: data.contact.KnownContactUserId,
            ImFollowing: true,
            FollowingMe: _path(['FollowingMe'], original),
            Connected: _path(['FollowingMe'], original)
        });

        connections = update;
    });

    return r;
};

const reset = () => {
    initOnce = false;
    connections = null;
    pending = [];
    error = false;
    cancel = null;
};

const Connections = {
    browse,
    add,
    reset
};

export default Connections;
